/**
 * LinkCardSkeleton Component
 * Loading skeleton for LinkCard
 */

import { Card, CardContent, CardFooter } from "./ui/card";
import { Skeleton } from "./ui/skeleton";

export function LinkCardSkeleton() {
  return (
    <Card className="overflow-hidden">
      {/* Image skeleton */}
      <Skeleton className="aspect-video w-full" />

      <CardContent className="p-4">
        {/* Title skeleton */}
        <Skeleton className="h-5 w-3/4" />

        {/* URL skeleton */}
        <Skeleton className="mt-2 h-4 w-1/2" />

        {/* Description skeleton */}
        <Skeleton className="mt-2 h-4 w-full" />
        <Skeleton className="mt-1 h-4 w-4/5" />

        {/* Metadata skeleton */}
        <div className="mt-3 flex items-center gap-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-4 w-24" />
        </div>
      </CardContent>

      <CardFooter className="border-t p-2">
        <div className="flex w-full justify-end gap-1">
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-9 w-9 rounded-md" />
        </div>
      </CardFooter>
    </Card>
  );
}
